import { useState, useEffect } from 'react';

export const deviceTypesEnum = {
	desktop: 'desktop',
	tablet: 'tablet',
	mobile: 'mobile'
}
const useResize = () => {
	const getDeviceType = width => {
		if (width >= 1024) return deviceTypesEnum.desktop;
		if (width >= 768) return deviceTypesEnum.tablet;
		return deviceTypesEnum.mobile;
	};

	const [deviceType, setDeviceType] = useState(getDeviceType(window.innerWidth));

	useEffect(() => {
		const handleResize = () => {
			setDeviceType(getDeviceType(window.innerWidth));
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return deviceType;
};

export default useResize;